export default class Validator {

  public static isUndefined(item: any): boolean {
    return typeof item === 'undefined';
  }

  public static isObject(item: any): boolean {
    return typeof item === 'object' && item !== null && !Array.isArray(item);
  }

  public static isArray(item: any): boolean {
    return Array.isArray(item);
  }

  public static checkIfArrayHasItems(items: Array<any>): number {
    return Array.isArray(items) ? items.length : 0;
  }

  public static checkIfObjectHasPropKeys(item: object): number {
    return Object.keys(item).length;
  }

  public static isValidEmail(email: string): boolean {
    const re = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/);
    return re.test(String(email).toLowerCase());
  }

  public static isValidPhoneNumber(msisdn: string): boolean {
    const re = /^06\d{7,8}/;
    return re.test(String(msisdn).toLowerCase());
  }

  public static isValidJmbg(jmbg: string): boolean {
    return (
      Boolean(jmbg) &&
      jmbg.length === 13 &&
      !isNaN(Number(jmbg))
    );
  }

}
